<template>
	<div class="avatar-page">
		<h2 class="level-one-heading">{{ tm('AVATAR') }}</h2>
		<hr class="_strong">
		<div class="mb-5">{{ ta('EXPLANATION') }}</div>
		<div class="avatar-editor pt-5">
			<div class="avatar-selector-wrap">
				<div class="avatar-item-selector-col">
					<avatar-item-selector :label="ta('AREA_BODY')" @equip="equip" area=2 :items="availableItems" :equippedItems="equippedItems" />
					<avatar-item-selector :label="ta('AREA_HAIR')" @equip="equip" area=7 :items="availableItems" :equippedItems="equippedItems" />
					<avatar-item-selector :label="ta('AREA_SHOULDERS')" @equip="equip" area=6 :items="availableItems" :equippedItems="equippedItems" />
					<avatar-item-selector :label="ta('AREA_WEAPON')" @equip="equip" area=10 :items="availableItems" :equippedItems="equippedItems" />
					<avatar-item-selector :label="ta('AREA_CAPE')" @equip="equip" area=1 :items="availableItems" :equippedItems="equippedItems" />
				</div>
				<div class="my-avatar">
					<ximg
						class="pixelated"
						:src="avatarSrc"
						:style="avatarStyle"
						ariaLabel="avatar"
						role="img"
					/>
				</div>
				<div class="avatar-item-selector-col">
					<avatar-item-selector :label="ta('AREA_FACE')" @equip="equip" :area="[8, 9]" :items="availableItems" :equippedItems="equippedItems" />
					<avatar-item-selector :label="ta('AREA_TORSO')" @equip="equip" area=5 :items="availableItems" :equippedItems="equippedItems" />
					<avatar-item-selector :label="ta('AREA_SHIELD')" @equip="equip" area=11 :items="availableItems" :equippedItems="equippedItems" />
					<avatar-item-selector :label="ta('AREA_LEGS')" @equip="equip" area=4 :items="availableItems" :equippedItems="equippedItems" />
					<avatar-item-selector :label="ta('AREA_FEET')" @equip="equip" area=3 :items="availableItems" :equippedItems="equippedItems" />
				</div>
			</div>
			<div class="col-md-12 px-0 pb-5">
				<div class="avatar-info-footer r-3 mb-4" :class="this.rankGroup.class">
					Lv. {{ user.rankLevel }} {{ user.avatar.class.title }}
				</div>
				<div class="avatar-stats">
					<div class="avatar-stat">
						<img :src="convertToCdnUrl('/img/icons/stats/Strength.svg')" alt="strength">
						<div>
							<span class="avatar-stat-name" style="color: #e27b89">{{ user.avatar.stats.strength }}</span><br>
							<span class="avatar-stat-type">Strength</span>
						</div>
					</div>
					<div class="avatar-stat">
						<img :src="convertToCdnUrl('/img/icons/stats/Dexterity.svg')" alt="dexterity">
						<div>
							<span class="avatar-stat-name" style="color: #8dc9a2">{{ user.avatar.stats.dexterity }}</span><br>
							<span class="avatar-stat-type">Dexterity</span>
						</div>
					</div>
					<div class="avatar-stat">
						<img :src="convertToCdnUrl('/img/icons/stats/Charm.svg')" alt="charm">
						<div>
							<span class="avatar-stat-name" style="color: #ad81b3">{{ user.avatar.stats.charm }}</span><br>
							<span class="avatar-stat-type">Charm</span>
						</div>
					</div>
					<div class="avatar-stat">
						<img :src="convertToCdnUrl('/img/icons/stats/Holy.svg')" alt="holy">
						<div>
							<span class="avatar-stat-name" style="color: #5abddd">{{ user.avatar.stats.holy }}</span><br>
							<span class="avatar-stat-type">Holy</span>
						</div>
					</div>
					<div class="avatar-stat">
						<img :src="convertToCdnUrl('/img/icons/stats/Wisdom.svg')" alt="wisdom">
						<div>
							<span class="avatar-stat-name" style="color: #cb6188">{{ user.avatar.stats.wisdom }}</span><br>
							<span class="avatar-stat-type">Wisdom</span>
						</div>
					</div>
				</div>
			</div>
			<div class="clearfix" />
		</div>
	</div>
</template>

<script>
import waja from 'waja';
import { t } from 'datastore/i18n';
import ximg from 'components/ximg';
import * as staticData from 'staticData';
import memberUtils from 'utils/member';
import { convertToCdnUrl } from 'utils';

export default {
	props: ['user'],
	data () {
		return {
			availableItems: [],
			equippedItems: [],
			randomAvatarHash: '',
		};
	},
	beforeRouteEnter (to, frm, next) {
		waja.get('avatar/item/unlocked')
			.on('success', (res) => {
				next((vm) => {
					const items = res.data.items;
					items.sort((i1, i2) => i2.unlockedAt - i1.unlockedAt);
					vm.availableItems = items;
					vm.equippedItems = res.data.equipped;
				});
			}).go();
	},
	methods: {
		convertToCdnUrl,
		tm: t.prefix('MEMBER'),
		ta: t.prefix('AVATAR'),
		equip (item, area) {
			const url = 'avatar/item/equip/' + area + '/' + (item ? item.id : null);
			console.log(url);
			waja.post(url)
				.on('success', res => {
					this.equippedItems = res.data.equipped;
					ximg.bustCache(this.avatarSrc);
					ximg.bustCache('/api/avatar/' + this.user.id);
				})
				.go();
		},
	},
	computed: {
		rankGroup () {
			return staticData.rankGroups[staticData.rankGroupMap[this.user.rankLevel]];
		},
		avatarSrc () {
			return '/api/avatar/' + this.user.id + '/?no-cache=1';
		},
		avatarStyle () {
			const backgroundImage = memberUtils.getBackgroundUrl(this.user);
			return {
				backgroundSize: 'cover',
				backgroundImage,
			};
		},
	},
};
</script>
